import { render, staticRenderFns } from "./details-address-item.vue?vue&type=template&id=69fdf01a&scoped=true&"
import script from "./details-address-item.vue?vue&type=script&lang=js&"
export * from "./details-address-item.vue?vue&type=script&lang=js&"
import style0 from "./details-address-item.vue?vue&type=style&index=0&id=69fdf01a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fdf01a",
  null
  
)

export default component.exports